import { observer } from 'mobx-react'
import {
  forwardRef,
  type DetailedHTMLProps,
  type InputHTMLAttributes
} from 'react'
import style from './Input.module.css'

export interface InputProps
  extends DetailedHTMLProps<
    InputHTMLAttributes<HTMLInputElement>,
    HTMLInputElement
  > {
  label?: string
  labelCSS?: undefined | string
  inputSize?: string
  customStyle?: string
}

const Input = forwardRef<HTMLInputElement, InputProps>((props, ref) => {
  const {
    label,
    customStyle = '',
    labelCSS = undefined,
    inputSize = 'default',
    ...inputProps
  } = props
  return (
    <>
      <div>
        {label && (
          <label htmlFor={inputProps.id} className={labelCSS ?? style.label}>
            {label}
          </label>
        )}
        <div className={['h-full', style[inputSize]].join(' ')}>
          <input
            ref={ref}
            className={[style.input, customStyle].join(' ')}
            {...inputProps}
          />
        </div>
      </div>
    </>
  )
})

Input.displayName = 'Input'

export default observer(Input)
